import axios from 'axios';
import { useEffect, useState } from 'react';

function Directions(props) {
  // getting the route from point A to point B
  const [directions, setDirections] = useState([]);

  const mapQuestKey = 'QMuPrv0lxox2LEiGRdd1j5rgvXJC2NTO';
  const directionsApi = 'https://www.mapquestapi.com/directions/v2/route';

  // MapQuest turnType: -1 end, 0 straight, 1 slight right, 2 right, 3 sharp right, 5 sharp left, 6 left, 7 slight left, 8/9 u-turn, 10 right merge, 11 left merge, 12-29 ramps/roundabouts
  function getDirectionIconClass(maneuver, index, total) {
    if (!maneuver) return 'fas fa-arrow-right';
    const turnType = maneuver.turnType;
    if (index === 0) return 'fas fa-play';
    if (turnType === -1 || (index === total - 1 && total > 1)) return 'fas fa-flag-checkered';
    switch (turnType) {
      case 0: return 'fas fa-arrow-up';
      case 1: return 'fas fa-chevron-right';
      case 2: return 'fas fa-arrow-right';
      case 3: return 'fas fa-arrow-right';
      case 5: return 'fas fa-arrow-left';
      case 6: return 'fas fa-arrow-left';
      case 7: return 'fas fa-chevron-left';
      case 8:
      case 9: return 'fas fa-undo';
      case 10:
      case 11: return 'fas fa-code-branch';
      case 12:
      case 13: return 'fas fa-arrow-right';
      case 14:
      case 15: return 'fas fa-arrow-left';
      case 16:
      case 17:
      case 18: return 'fas fa-code-branch';
      case 24:
      case 25:
      case 26:
      case 27:
      case 28:
      case 29: return 'fas fa-circle';
      default: return 'fas fa-arrow-right';
    }
  }

  useEffect(() => {
    axios({
      url: directionsApi,
      method: 'GET',
      dataResponse: 'json',
      params: {
        key: mapQuestKey,
        from: `${props.userCoordinates[0]},${props.userCoordinates[1]}`,
        to: `${props.destCoordinates[0]},${props.destCoordinates[1]}`,
      },
    }).then((res) => {
      const legs = res && res.data && res.data.route && Array.isArray(res.data.route.legs)
        ? res.data.route.legs
        : [];
      const maneuvers = legs[0] && Array.isArray(legs[0].maneuvers)
        ? legs[0].maneuvers
        : [];

      setDirections(maneuvers);
      // error handling
    }).catch((err) => {
      console.log('error occured!!!', `${err}`);
    });
  }, [props.userCoordinates, props.destCoordinates]);

  return (
    <>
    <button className="closeMap" onClick={props.mapOnOff}>
      <i className="far fa-times-circle"></i>
    </button>
    <div className="mapAndTextContainer"> 
      <div className="textContainer">
        {
          directions.map((item, index) => {
          return (
            <>
              <ol>
                <li key={index}>
                  <i className={`icons ${getDirectionIconClass(item, index, directions.length)}`} aria-hidden="true" />
                  <p>{item.narrative}</p>
                </li>
              </ol>
            </>
          )
      })}
    </div>
    <div className="leaflet-container flex-leaflet-container">
      <img src={`https://www.mapquestapi.com/staticmap/v5/map?key=${mapQuestKey}&start=${props.userCoordinates[0]},${props.userCoordinates[1]}&end=${props.destCoordinates[0]},${props.destCoordinates[1]}&zoom=15&size=1000,700@2x`} alt="directions map" className="mapDirections"/>
    </div>
  </div>
  </>
  );
}

export default Directions;
